import OBase from './OBase';

import * as Geometry from '../geometry';

export default class EMaterialList extends OBase {
  update () {
    const tTree = this.getFloatInput('thickness');
    const mOutput = this.getGenericObjectOutput('materialId');

    const thickness = tTree.branches[0][0];

    const gui = this.ghGeometryObject; // EMaterialListObject
    gui.filter(thickness);

    const oTree = new Geometry.DataTree();
    const selected = Number(this.ghGeometryObject.selected);
    if (selected >= 0 && selected < this.ghGeometryObject.values.length) {
      const value = this.ghGeometryObject.values[selected];
      oTree.add(value, new Geometry.GHPath(0));
    } else {
      oTree.add(-1, new Geometry.GHPath(0));
    }
    mOutput.value = oTree;
  }
}



// WEBPACK FOOTER //
// ./src/assets/javascripts/gh/components/EMaterialList.js